var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1663 19.4583H0.833008C0.491341 19.4583 0.208008 19.1749 0.208008 18.8333C0.208008 18.4916 0.491341 18.2083 0.833008 18.2083H19.1663C19.508 18.2083 19.7913 18.4916 19.7913 18.8333C19.7913 19.1749 19.508 19.4583 19.1663 19.4583Z",
    fill: "#093554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4834 19.4667C16.1417 19.4667 15.8584 19.1834 15.8584 18.8417V15.125C15.8584 14.7833 16.1417 14.5 16.4834 14.5C16.8251 14.5 17.1084 14.7833 17.1084 15.125V18.8417C17.1084 19.1834 16.8334 19.4667 16.4834 19.4667Z",
    fill: "#093554"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5003 15.75C15.142 15.75 14.042 14.65 14.042 13.2916V11.4C14.042 10.0417 15.142 8.94165 16.5003 8.94165C17.8587 8.94165 18.9587 10.0417 18.9587 11.4V13.2916C18.9587 14.65 17.8587 15.75 16.5003 15.75ZM16.5003 10.2C15.8337 10.2 15.292 10.7417 15.292 11.4083V13.3C15.292 13.9666 15.8337 14.5083 16.5003 14.5083C17.167 14.5083 17.7087 13.9666 17.7087 13.3V11.4083C17.7087 10.7417 17.167 10.2 16.5003 10.2Z",
    fill: "#093554"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9162 19.4583C11.5745 19.4583 11.2912 19.175 11.2912 18.8333V5.52498C11.2912 4.19998 10.7329 3.6333 9.43286 3.6333H4.24121C2.93288 3.6333 2.36621 4.19998 2.36621 5.52498V18.8333C2.36621 19.175 2.08288 19.4583 1.74121 19.4583C1.39954 19.4583 1.11621 19.175 1.11621 18.8333V5.52498C1.11621 3.49998 2.22454 2.3833 4.24121 2.3833H9.43286C11.4412 2.3833 12.5412 3.49998 12.5412 5.52498V18.8333C12.5412 19.175 12.2578 19.4583 11.9162 19.4583Z",
    fill: "#093554"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95802 8H4.83301C4.49134 8 4.20801 7.71667 4.20801 7.375C4.20801 7.03333 4.49134 6.75 4.83301 6.75H8.95802C9.29968 6.75 9.58302 7.03333 9.58302 7.375C9.58302 7.71667 9.29968 8 8.95802 8Z",
    fill: "#093554"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95802 11.125H4.83301C4.49134 11.125 4.20801 10.8417 4.20801 10.5C4.20801 10.1583 4.49134 9.875 4.83301 9.875H8.95802C9.29968 9.875 9.58302 10.1583 9.58302 10.5C9.58302 10.8417 9.29968 11.125 8.95802 11.125Z",
    fill: "#093554"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 19.4583C6.53333 19.4583 6.25 19.1749 6.25 18.8333V15.7083C6.25 15.3666 6.53333 15.0833 6.875 15.0833C7.21667 15.0833 7.5 15.3666 7.5 15.7083V18.8333C7.5 19.1749 7.21667 19.4583 6.875 19.4583Z",
    fill: "#093554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.8d0a748c2796f9379b5b5e39dbd56b0f.svg";
export { ForwardRef as ReactComponent };